import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { DatePicker, TimePicker } from 'material-ui-pickers';
import moment from 'moment';
import { remove } from 'lodash'

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import * as regData from '../../../../appConstants'

import * as decisiondetails from '../../../actions/decisiondetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as assigneeList from '../../../actions/assigneedetails';
import * as lookupMeetingList from '../../../actions/meetingdetails';


import AddSubDecision from "./addsubdecision";
import TableCell from './tablecell';

class AddDecision extends Component {

    constructor(props) {
        super(props);
        this.state = {
            DialogState: false,
            setValue: false,
            committee_id: Number(this.props.params.committee_id ? this.props.params.committee_id : this.props.loginUser.data.committee_id),
            id: this.props.params.id,
            decision: { id: '', subject: '', decision_number: 0, decision_date: moment().format('YYYY-MM-DD'), undercommittee_val: '', decisions: [] },
            meetingList: null,
            assigneeUserList: null,
            newSubDecision: null,
        };
    }

    componentDidMount() {
        // console.log('componentDidMount')
        if (this.state.id) {
            // console.log('this.state.id', this.state.id)
            this.props.actions.getDecisionDetails(this.state.id);
        }
        else
            this.state.decision = { id: '', subject: '', decision_number: '', decision_date: moment().format('YYYY-MM-DD'), undercommittee_val: '', decisions: [] }
        this.props.actions.lookupMeetingList(this.props.loginUser.data.committee_id);
        this.props.actions.getAssigneeDetailsList(this.props.loginUser.data.committee_id);
        this.props.actions.loadswitchercommittees();
        this.props.actions.getDecisionStatusLookupDetails();
    }

    handleChange(field, e) {

        if (field == 'decision_date') {
            // console.log(field, moment(e).format('DD-MM-YYYY'))
            let decision = Object.assign({}, this.state.decision, { [field]: moment(e).format('YYYY-MM-DD') });
            this.setState(Object.assign({}, this.state, { 'decision': decision }));
        }
        else {
            const decision = Object.assign({}, this.state.decision, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'decision': decision }));
        }
        // console.log(this.state.decision)
    }
    handleChangeTeam(e) {
        this.setState({ committee_id: Number(e.target.value) })
        this.changeTeam(e.target.value)
    }
    changeTeam(Committee_id) {
        if (!this.state.id)
            this.props.actions.getTeamUserList(Committee_id);

        this.props.loginUser.data.committee_id = Committee_id;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }
    getAddSubDecision = (data) => {
        // console.log('data', data)
        if (data && data.id == 0)
            this.state.decision.decisions.push(data);
        else {
            let _data = this.state.decision.decisions
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.decision.decisions, { id: data.id });
            // Replace item at index using native splice
            this.state.decision.decisions.splice(index, 1, data);
            // remove(_data, { id: data.id })
            // _data.push(data)
        }
        // console.log('decisions', this.state.decision.decisions)
    }

    getDeleteSubDecision = (data) => {
        if (data && data.id) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.decision.decisions, { id: data.id });
            // Replace item at index using native splice
            this.state.decision.decisions.splice(index, 1);
        }
        else if (data) {
            // Find item index using _.findIndex
            var index = _.findIndex(this.state.decision.decisions, data);
            // Replace item at index using native splice
            this.state.decision.decisions.splice(index, 1);
        }
        this.setState({ 'setValue': true });
    }
    openAddSubDecision = (data) => {
        // console.log('openAddSubDecision', data)
        this.state.newSubDecision = data
        this.setState({ newSubDecision: data })
        this.setState({ DialogState: true })
    }
    handleSubmit(e) {
        e.preventDefault();
        // console.log(this.state.decision)
        this.state.decision.undercommittee_val = this.state.committee_id
        if (this.state.decision.id && this.state.decision.id > 0)
            this.props.actions.updateDecisionDetails(this.state.decision);
        else
            this.props.actions.addDecisionDetails(this.state.decision);
    }
    handleRequestClose = () => {
        this.setState({ DialogState: false, newSubDecision: null });
    };

    render() {
        // console.log('render')
        const { match, loginUser, decisionDetails, params, teamDetails, meetingDetails, assigneeDetails } = this.props;
        // console.log('decisionDetails', this.props)
        let result = null;
        if ((decisionDetails && decisionDetails.Status) || (teamDetails && teamDetails.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        // console.log('this.state.committee_id', this.state.committee_id)
        if (decisionDetails && decisionDetails.decisiondetails && !this.state.setValue) {
            this.setState({ setValue: true })
            this.state.decision = decisionDetails.decisiondetails;
            if (this.state.committee_id != decisionDetails.decisiondetails.undercommittee_val) {
                this.setState({ committee_id: Number(decisionDetails.decisiondetails.undercommittee_val) })
                this.TeamChanged(decisionDetails.decisiondetails.undercommittee_val)
            }
        }
        if (assigneeDetails && assigneeDetails.assigneeDetailsList)
            this.state.assigneeUserList = assigneeDetails.assigneeDetailsList;
        if (meetingDetails && meetingDetails.switchmeetingdetailsList)
            this.state.meetingList = meetingDetails.switchmeetingdetailsList;
        let _TeamList = null
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }
        let _MeetingList = null
        if (this.state.meetingList && this.state.meetingList.length > 0) {
            _MeetingList = this.state.meetingList.map(meeting => (
                <MenuItem key={meeting.smeetingId} value={meeting.smeetingId}
                    style={{ fontWeight: '500' }}>
                    {meeting.meetingName}
                </MenuItem>
            ))
        }
        let _decisionList = null
        let decisions = this.state.decision.decisions
        if (decisions && decisions.length > 0) {
            _decisionList = decisions.map((_data, index) => {
                return (<TableCell key={index} data={_data} index={index}
                    id={this.state.decision.id} openAddSubDecision={this.openAddSubDecision.bind(this, _data)}
                    getDeleteSubDecision={this.getDeleteSubDecision.bind(this)}
                />);
            })
        }
        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Add Decision" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12 ">
                        <FormControl className="w-100 mb-4 col-md-3">
                            <InputLabel htmlFor="age-simple">Team Switcher</InputLabel>
                            <Select
                                value={this.state.committee_id}
                                onChange={this.handleChangeTeam.bind(this)}
                                input={<Input id="age-simple" />}
                                disabled={this.state.id ? true : false}
                            >
                                {_TeamList}
                            </Select>
                        </FormControl>
                        <ValidatorForm autoComplete="off" id="decision" name="decision" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">Decision Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-12">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="subject" label="Decision Text" multiline={true}
                                                validators={['required',regData.regexMultiLineExp,regData.regexMultiLineExpLength]}
                                                errorMessages={['This field is required',regData.messageMultilineRegexEx,regData.messageMultilineLength]}
                                                value={this.state.decision.subject} onChange={this.handleChange.bind(this, 'subject')} />
                                        </div>
                                        <div className="col-4">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="decision_number" label="Meeting Number"
                                                validators={['required',regData.regexAlphaNumeric,regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required',regData.messageAlphaNumeric,regData.messageLength]}
                                                value={this.state.decision.decision_number && this.state.decision.decision_number > '' ? this.state.decision.decision_number : ''}
                                                onChange={this.handleChange.bind(this, 'decision_number')} />
                                        </div>
                                        <div className="col-4">
                                            <DatePicker fullWidth value={this.state.decision.decision_date ? moment(this.state.decision.decision_date) : moment()}
                                                onChange={this.handleChange.bind(this, 'decision_date')}
                                                animateYearScrolling={false} label="Date"
                                                format="DD/MM/YYYY"
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />} rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />} />
                                        </div>
                                    </div>

                                    <Card className="shadow border-2 mt-4">
                                        <CardBody>
                                            <div className="row">
                                            <div class="row custrow w-100 justify-content-between">
                                            <h3 className="card-title">Sub Decisions</h3>
                                            <Button variant="raised" className="bg-primary text-white"
                                                        onClick={this.openAddSubDecision.bind(this, -1)}>Add Sub Decision</Button>
                                        </div>
                                        
                                        
                                                <div className="col-md-12">
                                                    
                                                    <div className="table-responsive-material">
                                                        <table className="default-table table-unbordered table table-lg table-hover">
                                                            <thead className="th-border-b">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Desicion Text</th>
                                                                    <th>Decision Number</th>
                                                                    {/* <th>Ministry</th> */}
                                                                    <th>Status</th>
                                                                    <th className="status-cell text-right">Actions</th>
                                                                    <th />
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {_decisionList}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/decision/decision-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                        <AddSubDecision open={this.state.DialogState} data={this.state.newSubDecision}
                            assigneeUserList={this.props.assigneeDetails.assigneedetailsList}
                            setAddSubDecision={this.getAddSubDecision} decisionlookup={this.props.decisionDetails.decisionlookup}
                            handleRequestClose={this.handleRequestClose.bind(this)} />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { loginUser, teamDetails, decisionDetails, meetingDetails, assigneeDetails } = state;
    const { match } = ownProps;
    return { match, loginUser, teamDetails, decisionDetails, params: ownProps.match.params, meetingDetails, assigneeDetails }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, loadswitchercommittees, lookupMeetingList, assigneeList, decisiondetails), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddDecision));



// WEBPACK FOOTER //
// ./app/decisiondetails/adddecision/index.js